var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.313 35.325c-.281 0-.506-.113-.731-.338L1.463 19.912c-.956-1.068-.956-2.756 0-3.768L15.582 1.012a1.04 1.04 0 0 1 1.406-.056 1.04 1.04 0 0 1 .056 1.406L2.87 17.437c-.282.282-.282.788 0 1.125l14.174 15.076c.394.393.338 1.012-.056 1.406-.168.169-.45.281-.675.281Z",
    fill: "#163144"
  })));
};
export default SvgArrowLeft;